import { Component, OnInit } from '@angular/core';
import { ManufacturerInterface, ReportManufacturerInterface } from 'src/app/util/interfaces/manufacturer';
import { ManufacturerService } from './service/manufacturer.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { faCheckSquare, faLock, faPencil, faSlash, faSquare, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';

@Component({
	selector: 'register-form-manufacturer',
	templateUrl: './manufacturer.component.html',
	styleUrls: ['./manufacturer.component.scss'],
})
export class ManufacturerComponent implements OnInit {
	icons = {
		faCheckSquare: faCheckSquare,
		faSquare: faSquare,
		faPencil: faPencil,
		faToggleOn: faToggleOn,
		faToggleOff: faToggleOff,
		faLock: faLock,
	};

	labels: any = {
		lbl_fabricante_cadastre_altere_fabricante: 'Register a new manufacturer or change the name of an existing one',
		lbl_asset_fabricante: 'Manufacturer',
		lbl_geral_salvar: 'Save',
		lbl_geral_selecione: 'Select',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_ativado: 'Activated',
		lbl_status_desativado: 'Inactive',
		lbl_geral_versao: 'Version',
		lbl_geral_motivo: 'Reason',
		lbl_geral_cliente: 'Customer',
		lbl_geral_limpar_campos: 'Clear Fields',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
	};

	isLoadingLabels = true;
	isLoadingManufacturers = true;

	placeholder = '';
	clearValues = false;
	inputHeight = '';

	clearValuesManufacturer = false;
	unselectValue = true;
	manufacturerList: ManufacturerInterface[] = [];
	placeholderManufacturer = '';

	selectedTab = 'manufacturer';

	manufacturer = {} as ManufacturerInterface;
	customInterface: ManufacturerInterface = {
		id: undefined,
		manufacturer: '',
		active: '',
		version: '',
		customer: '',
		message: '',
	};

	searchText = '';
	searchTextReport = '';
	filteredItems: ManufacturerInterface[] = [];

	showForm = false;
	showAlterForm = false;
	selectedItem = null;
	allSelected = false;

	unbondList = [];

	checkedOptions: { [id: string]: boolean } = {};

	//Log Fabricantes
	reportManufacturerList: ReportManufacturerInterface[] = [];
	filteredReport: ReportManufacturerInterface[] = [];
	isReportVisible = false;

	searchHeader: mspTableHeaderI[] = [
		{ name: 'manufacturer', value: 'lbl_asset_fabricante', colType: 'text' },
		{ name: 'version', value: 'lbl_geral_versao', colType: 'text' },
		{ name: 'active', value: 'lbl_geral_ativo', colType: 'boolean' },
		{ name: 'icon', value: 'lbl_bulletin_actions', colType: 'icon' },
	];

	constructor(
		private manufacturerService: ManufacturerService,
		private notification: NotificationService,
		private labelsService: LabelsService
	) {}

	ngOnInit(): void {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.getAllManufacturers();
		this.filteredItems = this.manufacturerList;
	}

	getManufacturer(id: string): void {
		this.manufacturerService.getManufacturerById(id).subscribe((data) => {
			this.customInterface = data;
			this.isLoadingManufacturers = false;

			if (this.checkedOptions[id]) {
				this.customInterface.isChecked = true;
			}
		});
	}

	saveManufacturer() {
		if (this.customInterface.id === '') {
			this.manufacturerService.postManufacturer(this.customInterface).subscribe((data) => {
				if (data[0].status == 'Error') {
					this.clearInputs(false);
					return this.notification.setNotificationMessage(this.labels.lbl_geral_fabricante_nome_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.cleanValues();
					this.clearInputs(false);
					this.getAllManufacturers();
				}
			});
		}
		if (this.customInterface.id || '') {
			this.manufacturerService.updateManufacturer(this.customInterface).subscribe((data) => {
				if (data[0].status == 'Error') {
					this.clearInputs(false);
					return this.notification.setNotificationMessage(this.labels.lbl_geral_fabricante_nome_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_successful_updated);
					this.cleanValues();
					this.clearInputs(false);
					this.getAllManufacturers();
				}
			});
		}
	}

	clearInputs(isNew: boolean) {
		this.clearValuesManufacturer = true;
		setTimeout(() => {
			this.clearValuesManufacturer = false;
		}, 1);

		this.customInterface = {
			id: isNew ? '' : undefined,
			manufacturer: '',
			active: '',
			version: '',
			customer: '',
			message: '',
		};

		this.filteredReport = [];
		this.showForm = true;
		this.isReportVisible = false;
	}

	cleanValues() {
		this.customInterface = {
			id: '',
			manufacturer: '',
			active: '',
			version: '',
			customer: '',
			message: '',
		};

		this.searchText = '';
		this.manufacturerList = [];
		this.unbondList = [];
		this.filteredItems = [];
		this.showForm = false;
		this.showAlterForm = false;
		this.allSelected = false;
		this.getAllManufacturers();
		this.searchItems();
		this.isLoadingManufacturers = true;
	}

	validateForm() {
		if (this.customInterface.manufacturer === '' || this.customInterface.manufacturer === null) {
			this.notification.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return false;
		} else {
			this.saveManufacturer();
		}
	}

	getAllManufacturers() {
		this.manufacturerService.getAllManufacturers().subscribe((res) => {
			this.manufacturerList = res;
			this.isLoadingManufacturers = false;
		});
	}

	selectAll() {
		this.allSelected = !this.allSelected;
		this.unbondList = [];
		this.showAlterForm = false;
		this.customInterface.message = '';

		const items = this.filteredItems.length > 0 ? this.filteredItems : this.manufacturerList;

		for (const item of items) {
			if (item.version !== 'Manualmente') {
				continue;
			}
			item.isChecked = this.allSelected;
			if (this.allSelected) {
				this.unbondList.push(item);
				this.showAlterForm = true;
			}
		}
	}

	selectMultiple(item, index?): void {
		item.isChecked = !item.isChecked;
		this.checkedOptions[item.id] = item.isChecked;
		this.customInterface.message = '';

		if (item.isChecked) {
			this.unbondList.push(item);
		} else {
			const idIndex = this.unbondList.findIndex((object) => object.id === item.id);
			this.unbondList.splice(idIndex, 1);
		}

		this.showAlterForm = this.unbondList.length === 0 ? false : true;
	}

	searchItems() {
		this.filteredItems = this.manufacturerList.filter((item) => {
			return (
				item.manufacturer.toLowerCase().includes(this.searchText.toLowerCase()) ||
				item.version.toLowerCase().includes(this.searchText.toLowerCase()) ||
				(item.active === 1 && this.labels.lbl_geral_ativo.toLowerCase().includes(this.searchText.toLowerCase())) ||
				(item.active === 0 && this.labels.lbl_geral_desativado.toLowerCase().includes(this.searchText.toLowerCase()))
			);
		});
	}

	searchReport() {
		this.filteredReport = this.reportManufacturerList.filter((item) => {
			return (
				(item.full_name && item.full_name.toLowerCase().includes(this.searchTextReport.toLowerCase())) ||
				(item.date_time && item.date_time.toLowerCase().includes(this.searchTextReport.toLowerCase())) ||
				(item.message && item.message.toLowerCase().includes(this.searchTextReport.toLowerCase()))
			);
		});
	}

	desactiveManufacturer(ids, message) {
		const manufacturerIds = Array.isArray(ids) ? ids.map((item) => item.id) : [ids];
		const messageInterface = this.customInterface.message;
		this.manufacturerService.deleteManufacturer(manufacturerIds, messageInterface).subscribe(() => {
			this.notification.setNotificationMessage(this.labels.lbl_status_desativado);
			this.cleanValues();
			this.clearInputs(false);
			this.getAllManufacturers();
		});
	}

	desactiveSelectedManufacturers(event: Event): void {
		let selectedIds: any = '';

		if ((<HTMLElement>event.target).classList.contains('double-click')) {
			const message = this.customInterface.message;
			selectedIds = this.unbondList.length === 0 ? this.customInterface.id : this.unbondList;

			this.desactiveManufacturer(selectedIds, message);
			this.unbondList = [];
		} else {
			(<HTMLElement>event.target).classList.add('double-click');

			setTimeout(() => {
				(<HTMLElement>event.target).classList.remove('double-click');
			}, 2000);
		}
	}

	activeManufacturer(ids, message) {
		const manufacturerIds = Array.isArray(ids) ? ids.map((item) => item.id) : [ids];
		const messageInterface = this.customInterface.message;
		this.manufacturerService.activeManufacturer(manufacturerIds, messageInterface).subscribe(() => {
			this.notification.setNotificationMessage(this.labels.lbl_geral_ativado);
			this.cleanValues();
			this.clearInputs(false);
			this.getAllManufacturers();
			this.showForm = false;
		});
	}

	activeSelectedManufacturers(event: Event): void {
		let selectedIds: any = '';

		if ((<HTMLElement>event.target).classList.contains('double-click')) {
			const message = this.customInterface.message;
			selectedIds = this.unbondList.length === 0 ? this.customInterface.id : this.unbondList;
			this.activeManufacturer(selectedIds, message);
			this.unbondList = [];
		} else {
			(<HTMLElement>event.target).classList.add('double-click');

			setTimeout(() => {
				(<HTMLElement>event.target).classList.remove('double-click');
			}, 2000);
		}
	}

	openForm(item: ManufacturerInterface) {
		this.isReportVisible = false;
		this.isReportVisible = true;

		this.selectedItem = item;
		this.customInterface = { ...item } as ManufacturerInterface;
		this.customInterface.message = '';

		this.showForm = true;
	}

	getReportManufacturer(id: number) {
		this.manufacturerService.getReportManufacturer(id).subscribe((manufacturers) => {
			this.reportManufacturerList = manufacturers;
			this.filteredReport = manufacturers;
		});
	}
}
